export default __webpack_public_path__ + "static/media/brewery_1280.e41a9d77.webp";